export default "__VITE_ASSET__xOzpzXZi__"